import { ModalWithVersion } from '@/components/core/Modal/WithVersion';
import { useModal } from '@/hooks/modals/useModal';
import { useSearchParams } from '@/hooks/useSearchParams';
import useTranslation from 'next-translate/useTranslation';
import { PropsWithChildren } from 'react';
import { LastMatchesModalProps } from './props';

export default function LastMatchesModal({
  modal,
  title,
  openCondition = true,
  children,
}: PropsWithChildren<LastMatchesModalProps>) {
  const { t } = useTranslation('modal');
  const { isOpen } = useModal(modal);
  const search = useSearchParams();
  const gameId = Number(search.get('game-id'));

  return (
    <ModalWithVersion
      condition={isOpen && !!gameId && openCondition}
      title={t(title)}
      modal={modal}
    >
      {children}
    </ModalWithVersion>
  );
}
